// @ts-nocheck
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useInventoryItems() {
  return useQuery({
    queryKey: ["inventory-items"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("manage_inventory_items")
        .select("*")
        .order("name");
      if (error) throw error;
      return data;
    },
  });
}

export function useWarehouses() {
  return useQuery({
    queryKey: ["warehouses"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("manage_warehouses")
        .select("*")
        .eq("is_active", true)
        .order("name");
      if (error) throw error;
      return data;
    },
  });
}

export function useWarehouseInventory() {
  return useQuery({
    queryKey: ["warehouse-inventory"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("manage_warehouse_inventory")
        .select("*, item:manage_inventory_items(*), warehouse:manage_warehouses(*)");
      if (error) throw error;
      return data;
    },
  });
}

export function useTransfers() {
  return useQuery({
    queryKey: ["inventory-transfers"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("manage_inventory_transfers")
        .select("*, item:manage_inventory_items(*), from_warehouse:manage_warehouses!manage_inventory_transfers_from_warehouse_id_fkey(*), to_warehouse:manage_warehouses!manage_inventory_transfers_to_warehouse_id_fkey(*)")
        .order("created_at", { ascending: false });
      if (error) throw error;
      return data;
    },
  });
}

export function useOrders() {
  return useQuery({
    queryKey: ["inventory-orders"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("manage_inventory_orders")
        .select("*, item:manage_inventory_items(*), destination_warehouse:manage_warehouses(*)")
        .order("created_at", { ascending: false });
      if (error) throw error;
      return data;
    },
  });
}

export function useUpcomingEvents() {
  return useQuery({
    queryKey: ["upcoming-events-for-inventory"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("events")
        .select("id, name, start_date, end_date, venue_id, venue_name, venue_city, additional_venue_ids")
        .gte("end_date", new Date().toISOString().split("T")[0])
        .order("start_date");
      if (error) throw error;
      return data;
    },
  });
}

export function useEventAllocations(eventId: string | null) {
  return useQuery({
    queryKey: ["event-allocations", eventId],
    enabled: !!eventId,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("manage_event_venue_allocations")
        .select("*, item:manage_inventory_items(*)")
        .eq("event_id", eventId!);
      if (error) throw error;
      return data;
    },
  });
}
